import React from 'react';
import PropTypes from 'prop-types';
import {  useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AccessDenied from '../elements/AccessDenied';
import LoadingSpinner from '../elements/LoadingSpinner';

const ProtectedRoute = ({ children, requiredRole }) => {
    const { isAuthenticated, loading, hasRole } = useAuth();
    const location = useLocation();

    if (loading) {
        return <LoadingSpinner />;
    }

    if (!isAuthenticated) {
        return <AccessDenied 
            message="Please log in to access this feature"
            returnPath={location.pathname}
        />;
    }

    if (requiredRole && !hasRole(requiredRole)) {
        return <AccessDenied 
            message="You don't have permission to access this feature"
            showLogin={false}
        />;
    }
    return children;
};

ProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired,
    requiredRole: PropTypes.string
};

export default ProtectedRoute;